<script setup>
import { computed } from "vue"
import { createToaster } from "@meforma/vue-toaster"

const props = defineProps({
  keywordBlocks: {
    type: Array,
    default: () => []
  }
})

const toaster = createToaster({
  position: "bottom-right",
  duration: 4000,
})

const blockedKeywords = computed(() => {
  return props.keywordBlocks.filter(block => block.keyword)
})

const copyBlockedKeywords = () => {
  if (blockedKeywords.value.length === 0) return

  const text = blockedKeywords.value.map(block => block.keyword).join('\n')
  navigator.clipboard.writeText(text).then(() => {
    toaster.show("Blocked sources copied to clipboard", { type: "success" })
  })
}
</script>

<template>
  <div>
    <div v-if="blockedKeywords.length === 0" class="text-sm text-base-content/60">
      No blocked sources for your account.
    </div>

    <div v-else>
      <div class="flex justify-between items-center mb-4">
        <p class="text-sm text-base-content/60">
          The following sources are blocked across all campaigns on your account.
        </p>
        <button
          @click="copyBlockedKeywords"
          v-tooltip="'Copy all blocked sources to clipboard'"
          class="btn btn-sm btn-ghost"
        >
          <v-icon name="hi-clipboard-copy" scale="1" />
          <span class="ml-1">Copy ({{ blockedKeywords.length }})</span>
        </button>
      </div>

      <div class="overflow-x-auto">
        <table class="table table-sm w-full">
          <thead>
            <tr class="text-base-content/60">
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="block in blockedKeywords" :key="block.id">
              <td class="font-mono text-error">{{ block.keyword }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
